import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import '../styles/Specializations.css';

function ConsumerProtectionLaw() {

  useEffect(() => {
    document.title = "ConsumerProtection Law - Legal Trails";  // Set Page Title
  }, []);

  return (
    <>
    <Navbar />
    <div className="law">
      
      <section className="specializations-detail">
        <div className="container">
          <div className="header-image"> 
            <img 
              src="/Consumer-Protection-Laws-Image.jpg" 
              alt="Consumer Protection Law" 
              loading="lazy" 
              onLoad={(e) => e.target.style.opacity = 1}
              style={{ opacity: 0, transition: "opacity 0.3s ease-in-out" }} 
            />
          </div>
          <div className="content">
            <p>
              Consumer protection law is essential for safeguarding the rights of consumers and ensuring fair business practices. At Legal Trails, we offer comprehensive legal services to address a range of issues related to consumer rights, product safety, and unfair trade practices. Our expertise includes advising clients on their rights and remedies under applicable laws and regulations, as well as representing consumers in disputes with businesses concerning product defects, misleading advertising, and unfair trade practices. We handle cases related to product liability, warranty claims, and service contracts, providing clients with the support they need throughout the process. Additionally, we assist clients in filing complaints with consumer protection agencies and pursuing legal action for damages when necessary. Our team also offers guidance on compliance with consumer protection laws, ensuring that businesses adhere to regulations while protecting consumer interests.
            </p>
            <div className="button-container">
              <Link to="/contact">
                <button>Contact Us</button>
              </Link>
            </div>
          </div>
        </div>
      </section>

    </div>
    <Footer />
    </>
  );
}

export default ConsumerProtectionLaw;
